
import NeedHelp from './NeedHelp';
import Hero from './Hero';
import { useEffect, useRef } from 'react';

function Home() {
  const containerRef = useRef(null)

    useEffect(() => {
      if(containerRef.current) {
        containerRef.current.parentNode.parentNode.scrollIntoView({ behavior: "smooth", block: "start", inline: "start" })
      }
    }, [containerRef])
    return <>
    
      {/* <div className="flex flex-col items-end pt-12 w-[80%] z-[1]">
        <p className="font-bold text-4xl text-[#ffba00] text-right w-[70%]">Total Solar is committed to deliver the top-tier Solar solutions for your Home and Business Sites. </p>
        <p className="font-bold text-base text-white text-right w-[40%]">Embrace a sustainable future, save on energy costs, and make a positive impact on the environment.</p>
        <div className="bg-[#ffba00] px-6 py-3 mt-2 rounded-full text-sm font-bold">Learn more</div>
      </div>
      <img src={bg} className='absolute z-[0] opacity-85 h-full w-full top-0 right-0 object-cover' />
      <div className="h-auto bg-black text-white w-full mt-12 flex justify-center z-[1]">
        <div className="w-[80%] flex flex-col md:flex-row justify-between items-center p-4">
            <div className="w-full md:w-[50%] px-2">
                <img className="h-auto object-contain" src={pic}/>
            </div>
            
            <div className="w-full md:w-[50%] px-2 text-left flex flex-col">
                <p className="font-bold text-2xl text-left text-[#ffba00]">Save on your electricity now! Go with Total Solar.</p>
                <p className="italic text-md text-left py-5">Request a quotation or schedule a site visit with our Professional Engineers.</p>
                <Link to={'/contact'} className="bg-[#ffba00] px-6 py-3 mt-2 mb-3 rounded-full text-lg font-bold w-fit text-black text-center">Contact us</Link>
            </div>

        </div>
      </div>

      <div className="h-auto bg-[#f5f5f5] text-black w-full flex justify-center z-[1]">
        <div className="w-[80%] flex flex-col md:flex-row justify-between p-4">
            <div className="w-full md:w-[50%] text-left flex flex-col">
                <p className="text-[#ffba00] font-extrabold text-2xl">Services offered</p>
                <ul className="list-disc pl-10 py-3 font-medium text-sm">
                    <li>Feasibility Study</li>
                    <li>Design and Engineering</li>
                    <li>Permitting and Applications</li>
                    <li>Installations and Commisioning</li>
                    <li>Troubleshooting</li>
                </ul>
                <p className='text-sm'>With our expertise in the solar energy industry, we strive to bring you the most efficient and cost-effective solar solutions available.</p>
            </div>
            <div className="w-full md:w-[50%] flex flex-row justify-between">
                <img className="w-1/2 h-auto object-contain pr-1" src={pic}/>
                <img className="w-1/2 h-auto object-contain pl-1" src={pic}/>
            </div>
        </div>
      </div>
      

      <div className="h-auto bg-black text-white w-full flex justify-center z-[1]">
        <div className="w-[80%] flex flex-col items-center p-6">
            <p className="w-[70%] text-3xl text-[#ffba00] font-extrabold">Over 500 homes and business sites in the Philippines are Solar-powered by Total Solar</p>
            <div className="p-6 flex flex-col md:flex-row items-center">
            <img className="h-[100px] object-contain w-[200px] md:pr-10" src={monterrasaz}/>
            <img className="h-[100px] object-contain w-[200px]" src={kima}/>
            <img className="h-[70px] object-contain w-[200px]" src={nissan}/>
            </div>
        </div>
        
      </div> */}
        <div ref={containerRef}></div>
        <Hero/>
        <NeedHelp/>
    </>;
  }
  
  export default Home;